import { configuration } from '../configuration';

export interface SpaceData {
  tenant: string;
}

export type SpacesResponse = Record<string, SpaceData>;

const FETCH_TIMEOUT_MS = 2000;

export default class MerchandisingContentServiceClient {
  async getSpaces(): Promise<SpacesResponse> {
    const response = await fetch(
      `${configuration.urls.MERCHANDISING_CONTENT_SERVICE_CDN_URL}/space-locales?requestor=${configuration.requestor}`,
      {
        method: 'GET',
        signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching spaces: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}
